import React, { useState } from "react";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { api, fmt } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogDescription } from "@/components/ui/dialog";
import { toast } from "sonner";
import { Repeat, Trash2 } from "lucide-react";

export const RecurringManager = ({ cats, trigger }) => {
  const qc = useQueryClient();
  const [open, setOpen] = useState(false);
  const { data: recurring = [] } = useQuery({ queryKey: ["recurring"], queryFn: api.getRecurring, enabled: open });
  const catName = (id) => cats.find((c) => c.id === id)?.name || "Unassigned";
  const delMut = useMutation({ mutationFn: api.deleteRecurring, onSuccess: () => { qc.invalidateQueries({ queryKey: ["recurring"] }); toast.success("Recurring bill removed"); } });

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>{trigger}</DialogTrigger>
      <DialogContent className="bg-[#141a26] border-[#2a364f] text-slate-100 max-w-lg max-h-[80vh] overflow-hidden flex flex-col">
        <DialogHeader>
          <DialogTitle className="font-heading flex items-center gap-2"><Repeat className="w-5 h-5 text-[#22c55e]" /> Recurring bills</DialogTitle>
          <DialogDescription className="text-slate-400">These auto-add to each upcoming month. Create one by ticking "Repeat monthly" when adding an expense.</DialogDescription>
        </DialogHeader>
        <div className="flex-1 overflow-y-auto space-y-2 pr-1">
          {recurring.length === 0 ? (
            <div className="py-10 text-center text-slate-500 text-sm">No recurring bills yet.</div>
          ) : (
            recurring.map((r) => (
              <div key={r.id} data-testid={`recurring-${r.id}`} className="flex items-center gap-3 rounded-xl bg-[#0a0e14] border border-[#2a364f] p-3">
                <div className="w-8 h-8 rounded-lg bg-[#22c55e]/15 flex items-center justify-center"><Repeat className="w-4 h-4 text-[#22c55e]" /></div>
                <div className="flex-1 min-w-0">
                  <div className="text-sm font-medium truncate">{r.merchant}</div>
                  <div className="text-[11px] text-slate-500">{catName(r.category_id)} · day {r.day} · {r.user}</div>
                </div>
                <span className="font-mono-num font-semibold">{fmt(r.amount)}</span>
                <Button variant="ghost" size="icon" data-testid={`delete-recurring-${r.id}`} onClick={() => delMut.mutate(r.id)} className="h-8 w-8 text-slate-500 hover:text-red-400 hover:bg-red-500/10"><Trash2 className="w-4 h-4" /></Button>
              </div>
            ))
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};
